<template>
  <request
    :get-compesatory-reposition-absence="getCompesatoryRepositionAbsence"
    :save-compensatory-request="saveCompensatoryRequest"
    :get-compensatory-request-student-service="
      getCompensatoryRequestStudentService
    "
    :get-educational-compensatory-request="getEducationalCompensatoryRequest"
    :request-service-data="serviceData"
    :is-read-only="isReadOnly || isEducational"
    :get-compensatory-reject-reasons="getRejectReasons"
    :download-document-by-attachment-id="downloadFile"
    @on-click-return="onClickReturnHandler"
  />
</template>

<script>
import { Request } from 'compensatory-service';
import {
  getCompesatoryRepositionAbsence as _getCompesatoryRepositionAbsence,
  getCompensatoryRequestStudentService as _getCompensatoryRequestStudentService,
  getEducationalCompensatoryRequest as _getEducationalCompensatoryRequest,
  saveCompensatoryRequest as _saveCompensatoryRequest,
  rejectReasons,
} from '@/modules/compensatory-service/api';
import documentsService from '@/services/documents';

export default {
  name: 'RequestWrapper',
  components: {
    Request,
  },
  data() {
    return {
      serviceData: null,
    };
  },
  computed: {
    isReadOnly() {
      return this.$route.params.hasCompletedRequest;
    },
    isEducational() {
      if (this.$route.query)
        return (
          this.$route.query.isEducational === true ||
          this.$route.query.isEducational === 'true'
        );

      return false;
    },
  },
  methods: {
    async downloadFile(fileId) {
      await documentsService.downloadDocumentByAttachmentIdOrDocumentId(fileId);
    },
    getCompensatoryRequestStudentService() {
      this.serviceData = this.$route.params;
      return _getCompensatoryRequestStudentService(this.serviceData);
    },
    getEducationalCompensatoryRequest(requestId = 0) {
      this.serviceData = this.serviceData = this.$route.params;
      return _getEducationalCompensatoryRequest(
        requestId == 0 ? this.$route.params.requestId : requestId
      );
    },
    saveCompensatoryRequest(params) {
      return _saveCompensatoryRequest(params);
    },
    getRejectReasons() {
      return rejectReasons();
    },
    onClickReturnHandler() {
      this.$router.go(-1);
    },
  },
};
</script>
